// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__2wXb2","visibleHandle":"Handle_visibleHandle__Iv8x6","dragged":"Handle_dragged__3-yn6"};